/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Src_3_DetailInputs */

const en_wb_marketing_src_3_detail = /** @type {(inputs: Wb_Marketing_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landing page and audience`)
};

const lv_wb_marketing_src_3_detail = /** @type {(inputs: Wb_Marketing_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galvenā lapa un auditorija`)
};

/**
* | output |
* | --- |
* | "Landing page and audience" |
*
* @param {Wb_Marketing_Src_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_src_3_detail = /** @type {((inputs?: Wb_Marketing_Src_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Src_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_src_3_detail(inputs)
	return en_wb_marketing_src_3_detail(inputs)
});